import { render, staticRenderFns } from "./BottomSheetNotGranted.vue?vue&type=template&id=7bb17135&scoped=true&"
import script from "./BottomSheetNotGranted.vue?vue&type=script&lang=js&"
export * from "./BottomSheetNotGranted.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetNotGranted.vue?vue&type=style&index=0&id=7bb17135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb17135",
  null
  
)

export default component.exports